import { Avatar, Box } from "@mui/material"
import DOMPurify from 'dompurify';
import { timeFormat } from "../../../core/global/Format";

export const Content = ({ itemData }) => {  
        const time = itemData !== null ? itemData.published_date : new Date();
        const postedTime = timeFormat(time);
        
        const decodeHTMLEntities = (str) => {
            const txt = document.createElement('textarea');
            txt.innerHTML = str;
            return txt.value;
        }
        
        const title = decodeHTMLEntities(DOMPurify.sanitize(itemData !== null ? itemData.title : '', { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }))
        const description = itemData.description.substring(0, 1200) + '...'

    return (
        <Box display="flex" flexDirection="column">
            <Box fontWeight="bold" fontSize="32px" my="32px">{title}</Box>
            <Box display="flex" alignItems="center" gap="32px" mb={itemData !== null ? (itemData.file_link === null ? '0px' : '24px') : '0px'}>
                <Box display="flex" alignItems="center" gap="16px">
                    <Avatar src={itemData !== null ? JSON.parse(itemData.profile).profile : null} alt="logo" variant='circular' sx={{width: '40px', height: '40px'}} />
                    <Box display="flex" flexDirection="column" gap="2px">
                        <Box fontSize="14px">{`${itemData !== null ? `${itemData.first_name} ${itemData.last_name} ` : 'Philtaxes'}`}</Box>
                        <Box fontSize="12px" color="#9BA0A6">{postedTime}</Box>
                    </Box>
                </Box>
                <Box height="14px" width="1px" bgcolor="#9BA0A6"/>
                <Box fontSize="12px">{itemData.category_name}</Box>
                <Box height="14px" width="1px" bgcolor="#9BA0A6"/>
                <Box fontSize="12px">{itemData.source_name}</Box>
            </Box>  
            <Box width="100%" display={itemData !== null ? (itemData.file_link === null ? 'none' : 'block') : 'none'}>
                <img src={itemData.file_link} alt="banner" style={{ maxHeight: '375px' ,height: '100%', width: '100%', borderRadius:'6px', objectFit: 'cover'}}/>
            </Box>
            <Box className="story-html" color="#292C2F"
                sx={{"*": {maxWidth: "100% !important",}, my: '24px'}}
                dangerouslySetInnerHTML={{ __html: description}}
            />
        </Box>
    )
}